var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'plv-iar-welfare-lottery__btn',
    ("plv-iar-welfare-lottery__btn--" + _vm.size),
    ("plv-iar-welfare-lottery__btn--" + _vm.type),
    {
      'plv-iar-welfare-lottery__btn--disabled': _vm.disabled
    }
  ],attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }